export const sports = [
  { id: 'Athletics', name: 'Athletics' },
  { id: 'Baseball', name: 'Baseball' },
  { id: 'Basketball', name: 'Basketball' },
  { id: 'Cricket', name: 'Cricket' },
  { id: 'Cycling', name: 'Cycling' },
  { id: 'Football / Soccer', name: 'Football / Soccer' },
  {
    id: 'Footy / Aussie Rules Football',
    name: 'Footy / Aussie Rules Football',
  },
  { id: 'Futsal', name: 'Futsal' },
  { id: 'Hockey', name: 'Hockey' },
  { id: 'Lacrosse', name: 'Lacrosse' },
  { id: 'Lawn Bowls', name: 'Lawn Bowls' },
  { id: 'Netball', name: 'Netball' },
  { id: 'Oztag', name: 'Oztag' },
  { id: 'Rugby', name: 'Rugby' },
  { id: 'Softball', name: 'Softball' },
  { id: 'Swimming', name: 'Swimming' },
  { id: 'Tennis', name: 'Tennis' },
  { id: 'Triathlon', name: 'Triathlon' },
  { id: 'Volleyball', name: 'Volleyball' },
];

export default null;
